import * as zod from 'zod';

export const confirmMasterAccountTexts = {
  title: 'Informe o número da sua conta',
  subtitle: 'A conta informada será definida como padrão para o recebimento de taxas.',
  labelAccount: 'Conta master',
  accountPlaceholder: 'número da conta',
  labelDigit: 'Dígito',
  digitPlaceholder: 'dígito',
  checkboxLabel: 'Esta conta não possui dígito',
  buttonBack: 'VOLTAR',
  buttonContinue: 'CONTINUAR',
};

export const getDefaultValues = (accountNumber: string, accountDigit: string) => ({
  account: accountNumber === '0' ? '' : accountNumber,
  digit: accountDigit,
});

export type MasterAccountForm = ReturnType<typeof getDefaultValues>;

export const getValidationCreateSchema = () =>
  zod
    .object({
      account: zod.string(),
      digit: zod.string(),
    })
    .refine((data) => !!data.account, {
      path: ['account'],
      message: 'Informe uma conta válida.',
    })
    .refine((data) => /^\d{5,7}$/.test(data.account), {
      path: ['account'],
      message: 'Informe uma conta válida.',
    })
    .refine((data) => /^[0-9X]$/.test(data.digit), {
      path: ['digit'],
      message: 'Informe um dígito valido ',
    });
